import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'src/utils/event';
import Button, { THEMES as BUTTON_THEMES } from 'HTKit/Forms/Button';
import MobileButtonFooter from './MobileButtonFooter';

const MobileFooterElement = ({ onClick = noop, buttonText = 'Continue', disabled = false }) => (
  <MobileButtonFooter>
    <Button
      theme={BUTTON_THEMES.V2PRIMARY}
      onClick={onClick}
      disabled={disabled}
    >
      {buttonText}
    </Button>
  </MobileButtonFooter>
);

MobileFooterElement.propTypes = {
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default MobileFooterElement;
